<template>
  <svg width="40" height="40" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="44" height="44" rx="22" fill="#14B8A6" />
    <path
      d="M16 29C16 30.1 16.9 31 18 31H26C27.1 31 28 30.1 28 29V17H16V29ZM29 14H25.5L24.5 13H19.5L18.5 14H15V16H29V14Z"
      fill="white"
    />
  </svg>
</template>

<script setup lang="ts"></script>
